import Duration from "../../utils/duration";
import { ITracker } from "../interfaces/tracker.interface";
import { Microservice } from "../model/microservice";
import { IPipeline } from "./pipeline.inferface";

export class TrackingMicroservicePipeline implements IPipeline<Microservice, Promise<Microservice>> {

	private pipeline: IPipeline<Microservice, Promise<Microservice>>;
	private tracker: ITracker;

	constructor(pipeline: IPipeline<Microservice, Promise<Microservice>>, tracker: ITracker) {
		this.pipeline = pipeline;
		this.tracker = tracker;
	}

	public async run(input: Microservice): Promise<Microservice> {

		const duration = new Duration();
		const output = await this.pipeline.run(input);

		this.tracker.trackEvent({
			url: input.marker.url,
			category: "Microservice",
			action: "Response",
			label: output.manifest.name,
			timeElapsed: duration.getDuration()
		});

		return output;
	}
}
